module.exports = __webpack_public_path__ + "img/sucesso.00a1ce1c.png";